<!--
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-03-31 17:24:33
 * @Description: file content
-->
<template>
  <Select v-model:value="state.value" show-search :placeholder="$lang('请输入')" 
    :default-active-first-option="false" :show-arrow="true" :filter-option="false" :not-found-content="state.fetching ? undefined : null"
    :options="state.data" @search="handleSearch" @change="handleChange">
    <template v-if="state.fetching" #notFoundContent>
      <Spin size="small" />
    </template>
    </Select>
</template>
<script lang="ts" setup>
import { reactive, nextTick, watch } from 'vue'
import { Select, Spin } from 'ant-design-vue'
import { debounce } from 'lodash-es'
import { useApi } from '@xinghai/site-common'
type option = {
  label: string,
  value: string
}
type Props = {
  value: string | Array<any> | undefined
  /**接口url */
  ajaxUrl: any
  /**入参的名字 */
  queryKey: string,
  labelKey?: string,
  valueKey?: string
  optionsData?: option[]
  labelFormatter?: (item: any) => string
  query: any
}
const props = withDefaults(defineProps<Props>(), {
  queryKey: 'name',
  labelKey: 'label',
  valueKey: 'value',
  query: {}
})
const box_list = useApi(props.ajaxUrl)
/**单选 */
const state = reactive({
  data: props.optionsData || [],
  value: props.value,
  fetching: false
})
const emit = defineEmits(['update:value', 'changeObj'])
const handleSearch = debounce((val: string) => {
  if (!val.trim()) return
  state.fetching = true
  box_list.fetchData({ ...props.query, [props['queryKey']]: val.trim() }).then((res) => {
    const data = res.data?.records || res.data || []
    state.data = data.map((_: any) => {
        return {
          ..._,
          label: props.labelFormatter ? props.labelFormatter(_) : _[props.labelKey],
          value: _[props.valueKey]
        }
      }).sort((a: { label: string }, b: { label: any }) => {
        return a.label.localeCompare(b.label)
      })
  }).finally(() => {
    state.fetching = false
  })
}, 300)

/**多选 */
watch(
  () => props.value,
  (c) => {
    state.value = c
  }
)
/**导出一个exportObj，包含选中当前行的所有数据 */
const handleChange = (val?: any) => {
  // value.value = val
  const item = state.data.find((_: any) => _.value === val)
  // emit('update:value', val)
  emit('update:value', val)
  nextTick(() => {
    emit('changeObj', item)
  })
}
defineExpose({ handleSearch })
</script>
<style lang="less" scoped></style>
